// ao criar novos parâmetros siga o exemplo abaixo

export enum AnalyticsDetailsParams {
  //Home
  detail_botao_modelo_remuneracao = 'botao:modelo-remuneracao',
  detail_botao_sumario_simulador = 'botao:sumario-simulador',
  // DETAILS
  detail_visualizacao_pagina = 'visualizacao-pagina',
  detail_com_entrada = 'com-entrada',
  detail_botao_beneficios_seguro = 'botao:beneficios-seguro',
  detail_elegivel_ao_seguro = 'elegivel-ao-seguro',
  //Historico upload filtro
  detail_botao_download_historico_upload = 'botao:download-historico-upload',
  detail_botao_consulta_historico_upload = 'botao:consulta-historico-upload',
  //Historico upload grid
  detail_botao_atualizar_historico_upload = 'botao:atualizar-historico-upload',
  detail_botao_excluir_historico_upload = 'botao:excluir-historico-upload',
  //Grid Investidor ETF
  detail_botao_editar_investidor_etf = 'botao:editar-investidor-etf',
  detail_botao_confirmar_exclusao_investidor_etf = 'botao:confirmar-exclusao-investidor-etf',
  detail_botao_cancelar_exclusao_investidor_etf = 'botao:cancelar-exclusao-investidor-etf',
  //Header/Navbar
  detail_botao_logout = 'botao:logout',
  //Movimentacoes ETF
  detail_botao_editar_operacao = 'botao:editar-operacao',
  detail_botao_excluir_operacao = 'botao:excluir-operacao',
  detail_botao_confirmar_exclusao_operacao = 'botao:confirmar-exclusao-operacao',
  detail_botao_cancelar_exclusao_operacao = 'botao:cancelar-exclusao-operacao',
  detail_botao_limpar_filtros = 'botao:limpar-filtros',
  detail_botao_aplicar_filtros = 'botao:aplicar-filtros',
  //Operacoes Upload
  detail_botao_download_relatorios = 'botao:download-relatorios',
  detail_botao_expandir_planilha = 'botao:expandir-planilha',
  detail_botao_retrair_planilha = 'botao:retrair-planilha',
  detail_botao_externo_modelo_remuneracao = 'botao:modelo-remuneracao',
  //Detalhes Operação
  detail_filtro_busca_modal_detalhes_op = 'filtro:busca-modal-detalhes-op',
  detail_filtro_limpar_modal_detalhes_op = 'filtro:limpar-modal-detalhes-op',
  //Novas Operacoes
  detail_botao_adicionar_operacao = 'botao:adicionar-operacao',
  detail_botao_recarregar_pagina_erro = 'botao:recarregar-pagina-erro',
  detail_botao_limpar_selecao = 'botao:limpar-selecao',
  detail_botao_excluir_operacao_lista = 'botao:excluir-operacao-lista',
  detail_botao_visualizar_pacs_operacao_lista = 'botao:visualizar-pacs-operacao-lista',
  detail_botao_confirmar_exclusao_operacao_lista = 'botao:confirmar-exclusao-operacao-lista',
  detail_botao_cancelar_exclusao_operacao_lista = 'botao:cancelar-exclusao-operacao-lista',
  detail_botao_voltar_novas_operacoes = 'botao:voltar-operacoes-upload',
  detail_botao_sair_novas_operacoes = 'botao:sair-operacoes-upload',
  detail_botao_cancelar_operacoes_inferior = 'botao:cancelar-operacoes-inferior',
  detail_botao_enviar_operacoes = 'botao:enviar-operacoes',
  detail_filtro_busca_modal_pac = 'filtro:busca-modal-pac',
  detail_filtro_selecionados_modal_pac = 'filtro:selecionados-modal-pac',
  detail_botao_limpar_filtros_modal_pac = 'botao:limpar-filtros-modal-pac',
  detail_botao_cancelar_modal_pac = 'botao:cancelar-modal-pac',
  detail_botao_confirmar_modal_pac = 'botao:confirmar-modal-pac',
  detail_botao_fechar_modal_pac = 'botao:fechar-modal-pac',
  //Operadores por Contas
  detail_botao_buscar_operadores = 'botao:buscar-operadores',
  detail_botao_editar_operador = 'botao:editar-operador',
  detail_botao_remover_todas_contas = 'botao:remover-todas-contas',
  detail_botao_remover_conta = 'botao:remover-conta',
  detail_botao_adicionar_todas_contas = 'botao:adicionar-todas-contas',
  detail_botao_adicionar_conta = 'botao:adicionar-conta',
  detail_botao_importar_de = 'botao:importar-de',
  detail_botao_modal_operador_confirmar_importacao = 'botao:modal-operador-confirmar-importacao',
  detail_botao_modal_operador_cancelar_importacao = 'botao:modal-operador-cancelar-importacao',
  detail_botao_modal_operador_sair = 'botao:modal-operador-sair',
  detail_botao_modal_operador_ficar = 'botao:modal-operador-ficar',
  //XML
  detail_botao_gerar_xml = 'botao:gerar-xml',
  detail_botao_gerar_xml_novamente = 'botao:gerar-xml-novamente',
  //Carteira Diaria
  //TODO - VERIFICAR SE INFO DE QUAL RELATORIO É ESSENCIAL
  detail_botao_gerar_relatorios_carteira_diaria = 'botao:gerar-relatorios-carteira-diaria',
  //Extratos - VERIFICAR SE INFO DE QUAL RELATORIO É ESSENCIAL
  detail_botao_buscar_extrato = 'botao:buscar-extrato',
  detail_botao_visualizar_extrato = 'botao:visualizar-extrato',
  //Relatorios Contabeis
  detail_botao_remover_consulta = 'botao:remover-consulta',
  detail_botao_retrair_central = 'botao:retrair-central',
  detail_botao_expandir_central = 'botao:expandir-central',
  //VERIFICAR SE INFO É NECESSARIA
  detail_botao_confirmar_salvamento = 'botao:confirmar-salvamento',
  detail_botao_ver_inconsistencias = 'botao:ver-inconsistencias',
  //XML
  detail_botao_xml_download_relatorios = 'botao:xml-download-relatorios',
  // VERIFICAR SE INFO É NECESSARIA
  detail_botao_buscar_registros_carteiras = 'botao:buscar-registros-carteiras',
  //Relatorios Contabeis - VERIFICAR SE INFO É NECESSARIA
  detail_botao_gerar_relatorios = 'botao:gerar-relatorios',
  //Login
  detail_botao_acessar = 'botao:acessar',
  //Footer
  detail_botao_termos_de_uso = 'botao:termos-de-uso',
  detail_botao_como_investir = 'botao:como-investir',
  detail_botao_novas_operacoes_fundos = 'botao:novas-operacoes-fundos',
  detail_botao_novas_operacoes_carteiras = 'botao:novas-operacoes-carteiras',
}
